import baseIsEqualDeep from "./_baseIsEqualDeep.js";
import isObjectLike from "./isObjectLike.js";
function baseIsEqual(value, other, bitmask, customizer, stack) {
  return value === other ? !0 : value == null || other == null || !isObjectLike(value) && !isObjectLike(other) ? value !== value && other !== other : baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
export {
  baseIsEqual as default
};
//# sourceMappingURL=_baseIsEqual.js.map
